/** @format */
import { InfiniteQueryObserverBaseResult } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export const useSearchResultsInfiniteScroll = ({
    showAll,
    hasNextPage,
    fetchNextPage,
}: {
    showAll: boolean;
    hasNextPage?: boolean;
    fetchNextPage?: InfiniteQueryObserverBaseResult['fetchNextPage'];
}) => {
    const [ref, inView] = useInView({
        rootMargin: '100px',
    });

    useEffect(() => {
        if (inView) {
            if (!showAll || !hasNextPage) {
                return;
            }

            fetchNextPage?.();
        }
    }, [inView]);

    return ref;
};
